import React from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from './cn';

/** Spinner xoay — dùng cho nút loading & loading-view. */
export function Spinner({ className, size = 20, label = 'Đang tải' }) {
  return (
    <Loader2
      className={cn('animate-spin text-brand-fg', className)}
      style={{ width: size, height: size }}
      role="status"
      aria-label={label}
    />
  );
}

/** Khối loading giữa trang/section. */
export function LoadingView({ className, label = 'Đang tải...', size = 28 }) {
  return (
    <div className={cn('flex flex-col items-center justify-center gap-3 py-12 text-muted', className)}>
      <Spinner size={size} />
      {label ? <p className="text-sm">{label}</p> : null}
    </div>
  );
}

export default Spinner;
